/** This component is to be added to Page Design placeholders like the Header and Footer for designs that don't require headers or footers.
 * It prevents the placeholder from showing up in Experience Editor when a page based on the design is being edited.
 */
const EmptyComponent = () => <></>;

export default EmptyComponent;
